<template>
  <div class="canvas-root">
    <div class="canvas-container" @click="onClickOutside" v-show="!isMinimized">
      <div class="canvas-bg" :style="bgStyle"></div>
      
      <!-- 👇 这两个 canvas 是核心，我帮你加固了 -->
      <canvas 
        ref="bgCanvas" 
        class="bg-canvas"
      ></canvas>
      <canvas 
        ref="drawCanvas" 
        class="draw-canvas"
      ></canvas>

      <!-- 右边工具栏不变... -->
      <div class="right-tool">
        <!-- 你的工具栏代码不变，直接保留 -->
        <div class="tool-item" :class="{active: !isEraser}" title="画笔" @click="switchToPen">
          <img src="@/ico/stutas/brush.svg" style="width:28px;" alt="">
          <div v-show="!isEraser" class="pen-drawer-fix">
            <div class="preview-box">
              <div class="circle" :style="{
                width: penSize + 'px',
                height: penSize + 'px',
                background: penColor
              }"></div>
            </div>
            <div class="slider-wrap">
              <input type="range" min="1" max="30" v-model.number="penSize" class="slider" />
              <span class="size-text">{{ penSize }}</span>
            </div>
          </div>
          <div v-show="!isEraser" class="color-group-vertical">
            <div v-for="c in colors" :key="c" class="color-dot" :style="{background:c}"
              @click="setPenColor(c)"></div>
            <div class="color-custom-btn" @click.stop="triggerColorPicker">其他</div>
          </div>
          <input ref="colorPicker" type="color" class="color-picker-fixed" v-model="penColor"
            @change="() => isEraser = false" />
        </div>

        <div class="tool-item" :class="{active: isEraser}" @click="switchToEraser">
          <img src="@/ico/stutas/eraser.svg" style="width:28px;" alt="">
          <div v-show="isEraser" class="eraser-drawer-fix">
            <div class="preview-box">
              <div class="circle" :style="{
                width: eraserSize + 'px',
                height: eraserSize + 'px'
              }"></div>
            </div>
            <div class="slider-wrap">
              <input type="range" min="5" max="50" v-model.number="eraserSize" class="slider" />
              <span class="size-text">{{ eraserSize }}</span>
            </div>
          </div>
        </div>

        <div class="tool-item" @click.stop="bgShow = !bgShow">
          <img src="@/ico/stutas/bg.svg" style="width:28px;" alt="">
          <div class="pop-panel" v-if="bgShow" @click.stop>
            <div class="pop-item" @click="setTransparentBg">透明</div>
            <div class="pop-item" @click="setWhiteBg">纯白</div>
          </div>
        </div>

        <div class="tool-item" @click="undo">
          <img src="@/ico/stutas/undo.svg" style="width:28px;" alt="">
        </div>

        <div class="tool-item" @click="clearCanvas">
          <img src="@/ico/stutas/clear.svg" style="width:28px;" alt="">
        </div>

        <div class="tool-item" @click="saveAndUpload" title="保存批注图片">
          <img src="@/ico/stutas/SaveImage.svg" style="width:28px;" alt="">
        </div>

        <div class="tool-item minimize-btn" @click.stop="toggleMinimize">
          <img src="@/ico/stutas/minimize.svg" style="width:28px;" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: "DrawCanvas",
		props: {
			bgType: {
				type: String,
				default: "white"
			},
			bgImageUrl: {
				type: String,
				default: ""
			},
			courseClassId: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				w: 0,
				h: 0,
				penSize: 6,
				eraserSize: 20,
				penColor: '#000000',
				colors: ['#000000', '#ff0000', '#0000ff', '#00ff00', '#ff9500', '#722ed1'],
				isEraser: false,
				isDraw: false,
				history: [],
				bgShow: false,
				bgCtx: null,
				drawCtx: null,
				isMinimized: false,
				bgStyle: {},
				
			}
		},
		watch: {
			bgType: {
				handler: "applyParentBg",
				immediate: true
			},
			bgImageUrl: {
				handler: "applyParentBg",
				immediate: true
			}
		},
		mounted() {
			this.initFullScreen()
			this.setWhiteBg()
		},
		methods: {
			async saveAndUpload() {
			  
			  try {
				  this.$emit('loading-start', '课堂批注上传中...') 
			    // 1. 创建新画布，把【背景图 + 笔迹】一起画进去
			    const mergeCanvas = document.createElement('canvas')
			    mergeCanvas.width = this.w
			    mergeCanvas.height = this.h
			    const ctx = mergeCanvas.getContext('2d')
			
			    // --------------------------
			    // 关键：先画背景（截图那张）
			    // --------------------------
			    if (this.bgStyle.backgroundImage) {
			      const url = this.bgStyle.backgroundImage.replace(/url\(["']?(.*?)["']?\)/, '$1')
			      const bgImg = new Image()
			    
			      // base64 不需要跨域，直接关闭
			      if (!url.startsWith('data:image')) {
			        bgImg.crossOrigin = 'anonymous'
			      }
			    
			      bgImg.src = url
			    
			      await new Promise((resolve, reject) => {
			        bgImg.onload = () => {
			          ctx.drawImage(bgImg, 0, 0, this.w, this.h)
			          resolve()
			        }
			        bgImg.onerror = reject
			      })
			    } else if (this.bgStyle.backgroundColor) {
			      // 纯白/透明背景
			      ctx.fillStyle = this.bgStyle.backgroundColor
			      ctx.fillRect(0, 0, this.w, this.h)
			    }
			
			    // --------------------------
			    // 再画笔迹（必须在背景上面）
			    // --------------------------
			    ctx.drawImage(this.$refs.drawCanvas, 0, 0)
			
			    // 2. 转成 File
			    const file = await this.canvasToFile(mergeCanvas)
			
			    // 3. 上传逻辑不变
			    const ossData = await this.getUploadParam()
			    if (!ossData) return
			
			    const realUrl = await this.uploadToOss(file, ossData)
			
			    if (realUrl) {
			      const formData = new FormData()
			      formData.append('fileId', ossData.uuid)
			      formData.append('originalFilename', file.name)
			      formData.append('filePath', realUrl)
			      formData.append('fileSize', file.size)
			      formData.append('fileType', file.type)
			      formData.append('businessType', 'teacherNote')
			      formData.append('schoolId', localStorage.getItem('orgId'))
			      formData.append('courseClassId', this.courseClassId)
			
			      await this.API.post(this.API.school.postUploadCallback, formData)
			      this.$message.success('保存成功')
				 // 1. 销毁画布内容
				  this.destroyCanvas();
				
				  // 2. 通知父组件：彻底关闭、刷新列表
				  this.$emit('upload-success');
				  this.$emit('close-and-refresh');
			    }
			  } catch (err) {
			    console.error('上传失败', err)
			    this.$message.error('保存失败')
			  } finally {
			    this.$emit('loading-end') 
			  }
			},

			// Canvas 转 File
			canvasToFile(canvas) {
				return new Promise((resolve) => {
					canvas.toBlob((blob) => {
						const file = new File([blob], 'canvas.png', {
							type: 'image/png'
						})
						resolve(file)
					}, 'image/png')
				})
			},
			// 请求后端获取上传签名
			getUploadParam() {
				return new Promise((resolve, reject) => {
					this.API.get(this.API.fileurl.getUploadParam, {
						type: 'teacherNote',
						schoolId: localStorage.getItem('orgId'),
						courseClassId: this.courseClassId
					}).then(res => {
						console.log('res.data.data', res.data)
						resolve(res.data)
					}).catch(err => {
						reject(err)
					})
				})
			},

			// 直传阿里云OSS
			async uploadToOss(file, ossData) {
				// ========== 1. 严格校验 ==========
				if (!file || !ossData) throw new Error('file 和 ossData 不能为空')
				if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数不完整')
				console.log('file', file)
				// ========== 2. 处理路径（解决双斜杠问题） ==========
				const host = ossData.host.replace(/\/$/, '') // 强制去掉末尾 /
				const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/' // 干净目录
				const ext = file.name.split('.').pop().toLowerCase() || 'png'
				const key = `${dir}${ossData.uuid}.${ext}`

				// ========== 3. 构建表单（严格按 OSS 顺序！file 必须最后） ==========
				const formData = new FormData()
				formData.append('key', key)
				formData.append('OSSAccessKeyId', ossData.accessKeyId)
				formData.append('policy', ossData.policy)
				formData.append('signature', ossData.signature) // 小写 s！有些后端返回小写
				formData.append('file', file)

				try {
					// ========== 4. 带超时的请求 ==========
					const controller = new AbortController()
					const timer = setTimeout(() => controller.abort(), 30000)

					const res = await fetch(host, {
						method: 'POST',
						body: formData,
						signal: controller.signal
					})

					clearTimeout(timer)

					// ========== 5. OSS 成功状态：200 或 204 都算成功！ ==========
					if (res.status === 200 || res.status === 204) {
						console.log('上传的大小', res)
						const url = `${host}/${key}`
						console.log('✅ 上传成功：', url)
						return url
					}

					// 失败
					const errMsg = await res.text()
					console.error('❌ OSS 报错：', res.status, errMsg)
					throw new Error(`上传失败（${res.status}）`)

				} catch (err) {
					console.error('❌ 上传异常：', err)
					const msg = err.name === 'AbortError' ? '上传超时' : err.message
					throw new Error('上传失败：' + msg)
				}
			},

			// ==========================
			// 以下是原有方法，保持不变
			// ==========================
			setParentBg(options) {
				if (options.type === 'white') {
					this.setWhiteBg()
				} else if (options.type === 'transparent') {
					this.setTransparentBg()
				} else if (options.type === 'image' && options.imageUrl) {
					this.$emit('loading-end') 
					this.bgStyle = {
						backgroundImage: `url(${options.imageUrl})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					}
					
				}
			},
			applyParentBg() {
				if (this.bgType === "white") {
					this.bgStyle = {
						backgroundColor: "#fff"
					};
				} else if (this.bgType === "transparent") {
					this.bgStyle = {
						backgroundColor: "transparent"
					};
				} else if (this.bgType === "image" && this.bgImageUrl) {
					this.bgStyle = {
						backgroundImage: `url(${this.bgImageUrl})`,
						backgroundSize: "cover",
						backgroundPosition: "center"
					};
				}
			},
			triggerColorPicker() {
				this.$refs.colorPicker.click()
			},
			toggleMinimize() {
				this.isMinimized = !this.isMinimized
				this.$emit('minimize', this.isMinimized)
			},
			saveCanvas() {
				const url = this.$refs.drawCanvas.toDataURL('image/png')
				this.$emit('save-success', url)
			},
			destroyCanvas() {
				this.drawCtx.clearRect(0, 0, this.w, this.h)
				this.bgCtx.clearRect(0, 0, this.w, this.h)
				this.history = []
			},
			onClickOutside() {
				this.bgShow = false
			},
			switchToPen() {
				this.isEraser = false
			},
			switchToEraser() {
				this.isEraser = true
			},
			setPenColor(c) {
				this.penColor = c;
				this.isEraser = false
			},
			initFullScreen() {
				this.w = window.innerWidth
				this.h = window.innerHeight
				const bg = this.$refs.bgCanvas
				const dr = this.$refs.drawCanvas
				bg.width = this.w
				bg.height = this.h
				dr.width = this.w
				dr.height = this.h
				this.bgCtx = bg.getContext('2d')
				this.drawCtx = dr.getContext('2d')
				  this.drawCtx.imageSmoothingEnabled = true
				  this.drawCtx.willReadFrequently = true
				this.bindEvents()
			},
			bindEvents() {
				const c = this.$refs.drawCanvas
				c.onmousedown = this.start
				c.onmousemove = this.move
				c.onmouseup = this.end
				c.onmouseleave = this.end
				c.ontouchstart = e => {
					e.preventDefault();
					this.start(e)
				}
				c.ontouchmove = e => {
					e.preventDefault();
					this.move(e)
				}
				c.ontouchend = e => {
					e.preventDefault();
					this.end(e)
				}
				c.addEventListener('touchstart', (e) => {
				    e.preventDefault();
				    this.start(e);
				  }, { passive: false });
				
				  c.addEventListener('touchmove', (e) => {
				    e.preventDefault();
				    this.move(e);
				  }, { passive: false });
				
				  c.addEventListener('touchend', (e) => {
				    e.preventDefault();
				    this.end(e);
				  }, { passive: false });
			},
			getPos(e) {
				if (e.touches) e = e.touches[0]
				return {
					x: e.clientX,
					y: e.clientY
				}
			},
			start(e) {
				this.isDraw = true
				const p = this.getPos(e)
				const ctx = this.drawCtx
				ctx.beginPath()
				ctx.moveTo(p.x, p.y)
				ctx.lineCap = 'round'
				ctx.lineJoin = 'round'
				if (this.isEraser) {
					ctx.globalCompositeOperation = 'destination-out'
					ctx.lineWidth = this.eraserSize
				} else {
					ctx.globalCompositeOperation = 'source-over'
					ctx.lineWidth = this.penSize
					ctx.strokeStyle = this.penColor
				}
			},
			move(e) {
				if (!this.isDraw) return
				const p = this.getPos(e)
				this.drawCtx.lineTo(p.x, p.y)
				this.drawCtx.stroke()
			},
			end() {
				if (this.isDraw) {
					this.isDraw = false
					this.history.push(this.drawCtx.getImageData(0, 0, this.w, this.h))
				}
			},
			setTransparentBg() {
				this.bgStyle = {
					backgroundColor: "transparent"
				}
				this.bgShow = false
			},
			setWhiteBg() {
				this.bgStyle = {
					backgroundColor: "#fff"
				}
				this.bgShow = false
			},
			onSelectBgImage(e) {
				const f = e.target.files[0]
				if (!f) return
				const url = URL.createObjectURL(f)
				this.bgStyle = {
					backgroundImage: `url(${url})`,
					backgroundSize: "cover",
					backgroundPosition: "center"
				}
			},
			resetDraw() {
				this.drawCtx.clearRect(0, 0, this.w, this.h)
				this.history = []
			},
			undo() {
				if (!this.history.length) return
				this.history.pop()
				this.drawCtx.clearRect(0, 0, this.w, this.h)
				if (this.history.length) this.drawCtx.putImageData(this.history.at(-1), 0, 0)
			},
			clearCanvas() {
				this.resetDraw()
			}
		}
	}
</script>

<style scoped>
/* 根容器：不再禁止事件 */
.canvas-root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}

.canvas-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  z-index: 9999;
}

.canvas-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* 核心：手写必须加 touch-action: none */
.bg-canvas,
.draw-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  touch-action: none;
  pointer-events: auto;
}

.right-tool {
  position: fixed;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
}

.tool-item {
  width: 58px;
  height: 38px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  position: relative;
}

.tool-item.active {
  background: #3b82f6;
  color: #fff;
}

.pen-drawer-fix,
.eraser-drawer-fix {
  position: absolute;
  left: -160px;
  top: 50%;
  transform: translateY(-50%);
  width: 150px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(0,0,0,0.15);
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 999;
}

.preview-box {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle {
  background: rgba(0,0,0,0.2);
  border-radius: 50%;
}

.slider-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.slider { flex:1; }
.size-text { font-size:12px; width:22px; text-align:right; }

.color-group-vertical {
  position: absolute;
  right: 70px;
  top: calc(50% + 60px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  z-index: 99;
}
.color-dot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #ddd;
}
.color-custom-btn {
  width: 26px;
  height: 26px;
  line-height: 26px;
  font-size: 10px;
  text-align: center;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 13px;
  cursor: pointer;
  color: #666;
}

.color-picker-fixed {
  position: absolute;
  right: 100px;
  top: calc(50% + 60px);
  opacity: 0;
  width: 20px;
  height: 20px;
  z-index: 99;
  pointer-events: none;
}

.pop-panel {
  position: absolute;
  right: 68px;
  top: 0;
  background: #fff;
  border-radius: 8px;
  padding: 6px 0;
  min-width: 90px;
  z-index: 999;
}
.pop-item {
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}

.minimize-ball {
  position: fixed;
  top: 20px;
  left: 20px;
  width: 44px;
  height: 44px;
  background: #1677ff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  pointer-events: auto;
}
</style>